<template>
  <div class="generator-review card p-4 mb-3" novalidate>
    <!-- Basic Information -->
    <h4>{{ $t("signup.se.generator_review.basic_information") }}</h4>

    <DynamicGeneratorField
      v-for="field in gridOwnerFields"
      :key="field.title"
      :field="field"
      v-model="
        localGenerator.application_information.go_application[field.model]
      "
      translationPrefix="signup.se"
    />
  </div>
</template>

<script setup lang="ts">
import DynamicGeneratorField from "@/signup/DynamicGeneratorField.vue";
import type { Account, Generator } from "@/types";
import { computed, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
import { getGridFields } from "./grid-fields";

const props = defineProps<{
  generatorIndex: number;
  companyIndex: number;
  accountData: Account;
}>();

const emit = defineEmits<{
  handleUpdateGenerator: [generator: Generator];
}>();

const { t } = useI18n();
const { gridOwnerFields } = getGridFields(t);

const generator = computed(() => {
  return props.accountData.companies[props.companyIndex].generators[
    props.generatorIndex
  ];
});

// Initialize with default values
const localGenerator = reactive({
  ...generator.value,
  application_information: {
    ...generator.value.application_information,
    go_application: {
      ...generator.value.application_information?.go_application,
      grid_owner_address: {
        ...generator.value.application_information?.go_application
          ?.grid_owner_address,
      },
    },
  },
});

watch(
  localGenerator,
  (newValue) => {
    emit("handleUpdateGenerator", newValue);
  },
  { deep: true }
);
</script>

<style scoped lang="scss">
.generator-review {
  h4 {
    margin-bottom: 1rem;
  }
}

@media (max-width: 575.98px) {
  h4 {
    font-size: 1.2rem;
  }
}
</style>
